<template>
  <div v-if="load">
    <scale-loader/>
  </div>
  <div v-else-if="profile == null">
    <div class="wrapper-full-page section content">
      <div class="">
        <div class="container">
          <div class="row">
            <div class="col-md-8 col-md-offset-2 text-center">
              <h2 class="title text-danger">
                Simcard: {{cur_id}} not found
              </h2>
              <router-link :to="{path:'/simcard_devices_list'}">
                To List Simcards Devices
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <tabs parent="simcard_devices" v-else>

    <tab id="profile" :name="translate('simcard_devices.section.profile')" :href="url+'/profile'" >
      <Profile :id="cur_id" :profile="profile" ref="profile" @change="set_simcard" />
    </tab>

    <tab id="traffic" :name="translate('simcard_devices.section.traffic')" :href="url+'/traffic'">
      <Traffic :sim_id="cur_id" />
    </tab>

    <tab id="tariff" :name="translate('simcard_devices.section.tariff')" :href="url+'/tariff'" :is-visible="profile.simcard_data.simcard_profile">
      <Tariff :sim_id="cur_id"/>
    </tab>

<!--    <tab id="actions" v-if="this.$store.getters.getPermissions?.controlSimcardProfile === true" :name="translate('simcard_devices.section.actions')" :href="url+'/actions'" :is-visible="profile.simcard_data.simcard_profile">-->
<!--      <Actions :sim_id="cur_id" :profile="profile"/>-->
<!--    </tab>-->

  </tabs>
</template>
<script>
import {Tabs, Tab} from 'components/UIComponents/Tabs'
import Profile from './Profile/Index.vue'
import Tariff from './Tariff/Index.vue'
import Traffic from './Traffic/Index.vue'
import Actions from "./Actions/Index.vue";

export default {
  name: 'SimCardDevices',
  components: {
    Actions,
    Profile,
    Tariff,
    Traffic,
    Tab,
    Tabs,
  },
  data () {
    return {
      pred_id: false,
      section: 'profile',
      interval: null,
      simcard: {},
      change: false
    }
  },

  beforeRouteLeave(to, from, next) {
    this.ProveSaveOnLeave(next)
  },

  beforeRouteUpdate(to, from, next) {
    this.ProveSaveOnLeave(next)
  },

  computed: {
    url () { return '/simcard_devices/' + this.$route.params.simcard_devices_id },
    cur_id () { return this.$route.params.simcard_devices_id },
    profile () { return this.simcard.profile },
    load () {
      if (this.simcard) {
        return this.simcard.load === undefined || this.simcard.load
      }
      return true
    }
  },
  watch: {
    cur_id () {
      if (this.cur_id && this.$route.name === 'simcard_devices_section') {
        this.set_simcard()
      } else {
        clearInterval(this.interval)
      }
    },
    $route () {
      if (this.$route.params.simcard_devices_section === undefined) {
        return false
      }
      if (this.pred_id !== this.cur_id && this.pred_id) {
        if (this.simcard.simcard_devices_section === undefined) {
          this.$router.push(this.section)
        } else {
          this.$router.push(this.simcard.section)
        }
      }
      this.pred_id = this.cur_id
      this.section = this.$route.params.simcard_devices_section
      this.$store.dispatch('updateSimcardDevicesSection', {id: this.cur_id, section: this.$route.params.simcard_devices_section})
    },
    load () {
      clearInterval(this.interval)
      if(this.load === false && this.simcard.profile !== null) {
        this.interval = setInterval(() => {
          this.$store.dispatch('updateSimcardDevicesProfile', this.cur_id)
        }, this.$store.getters.getSimcardDevicesProfileUpdate)
      }
    }
  },

  deactivated () {
    clearInterval(this.interval)
  },

  activated () {
    this.set_simcard()
  },

  methods: {
    OnChange (value) {
      this.change = value
    },
    ProveSaveOnLeave (next) {
      if(this.section === 'profile' && this.change) {
        const answer = window.confirm(this.translate('device.profile_not_save'))
        if (answer) {
          this.$refs.profile.cancel()
          next()
        } else {
          next(false)
        }
      } else {
        next()
      }
    },

    set_simcard () {
      if (this.cur_id) {
        this.simcard = this.$store.getters.getSimcardDevicesById(this.cur_id)
        if (!this.simcard.profile || !this.simcard.profile.ts || this.simcard.profile.ts < Date.now()) {
          this.$store.dispatch('updateSimcardDevicesProfile', this.cur_id)
        }
        this.$store.dispatch('updateSimcardDevicesList', this.simcard.profile)
      }
    },
  }
}

</script>
